import { Money } from '@jucy/rentals-api-client';

type MoneyShape = {
    currencyCode: string;
    value: number;
};

type LegacyMoneyShape = {
    CurrencyCode: string;
    Value: number;
};

export type CurrencyObject = MoneyShape | LegacyMoneyShape | Money;
export type CurrencyValue = number | string | CurrencyObject;

const isDefined = <T>(value: T): value is NonNullable<T> => value !== null && value !== undefined;

const resolveValue = (input?: CurrencyValue): number => {
    if (typeof input === 'number') {
        return input;
    }
    if (typeof input === 'string') {
        return Number(input);
    }
    if (typeof input === 'object') {
        if ('value' in input && isDefined(input.value)) {
            return input.value;
        } else if ('Value' in input && isDefined(input.Value)) {
            return input.Value;
        }
    }
    return 0;
};

const resolveCurrencyCode = (input?: CurrencyValue): string => {
    let result = 'NZD';
    if (typeof input === 'string') {
        result = input;
    } else if (typeof input === 'object') {
        if ('CurrencyCode' in input && isDefined(input.CurrencyCode)) {
            result = input.CurrencyCode;
        } else if ('currencyCode' in input && isDefined(input.currencyCode)) {
            result = input.currencyCode;
        }
    }
    return result;
};

export const formatCurrency = (value: CurrencyValue, currencyCode?: string): string => {
    const resolvedValue = resolveValue(value || 0);
    const resolvedCurrencyCode = resolveCurrencyCode(currencyCode || value);
    const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: resolvedCurrencyCode });
    return formatter.format(resolvedValue).replace(/^(-?)[A-Z]+/, '$1');
};

export const getCurrencyComponents = (value: string, separator = '.'): { dollars: string; cents: string } => {
    const result = String(value).split(separator);
    return { dollars: result[0] || '0', cents: result[1] || '00' };
};

export const roundCurrency = (value: CurrencyValue | number): number => {
    const resolvedValue = resolveValue(value);
    return Math.round((resolvedValue + Number.EPSILON) * 100) / 100;
};
